<template>
  <v-responsive :aspect-ratio="7 / 2" max-width="500">
    <v-container fluid fill-height class="py-0">
      <v-row align="center" justify="center">
        <v-skeleton-loader v-if="!preview" type="image" class="mx-auto"></v-skeleton-loader>
        <v-img v-if="isImage && preview" :src="preview"></v-img>
        <video
          v-if="isVideo && preview"
          controls
          autoplay
          loop
          muted
          playsinline
          style="width:100%;"
        >
          <source :src="preview" :type="type" />
        </video>
        <v-progress-circular
          v-if="showProgress"
          :rotate="360"
          :size="100"
          :width="15"
          :value="uploadProgress"
          style="position:absolute;margin-left:auto;margin-right:auto;left: 0;right: 0;text-align: center;z-index: 5;"
          color="green lighten-2"
        ></v-progress-circular>
        <v-alert
          v-model="showErrorAlert"
          type="error"
          style="position:absolute;margin-left:auto;margin-right:auto;left: 0;right: 0;text-align: center;z-index: 4;"
        >
          <v-row align="center">
            <v-col class="grow pa-0 ma-0">{{ fullErrorMessage }}</v-col>
            <v-col class="shrink pa-0 ma-0 ml-2">
              <v-btn fab dark color="green" @click="reloadFile">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-row>
    </v-container>
    <v-overlay :absolute="true" :value="darkenImage" :z-index="3" :opacity="0.7"></v-overlay>
  </v-responsive>
</template>

<script>
export default {
  props: {
    preview: {
      type: String
    },
    type: {
      type: String
    },
    uploadProgress: {
      type: Number
    },
    errorMessage: {
      type: Error
    },
    uploadStatus: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fullErrorMessage: '',
      error: false
    }
  },
  watch: {
    errorMessage: function(newVal) {
      if (!newVal) {
        this.fullErrorMessage = ''
        this.error = false
        return
      }
      this.error = true
      let errorPrefix = ''
      if (this.uploadStatus == 'error_criating_preview') {
        errorPrefix = 'Не получилось сделать превьюшку:'
      } else if (this.uploadStatus == 'error_getting_signed_url') {
        errorPrefix = 'Не удалось получить ключ загрузки:'
      } else if (this.uploadStatus == 'error_uploading') {
        errorPrefix = 'Не удалось загрузить:'
      } else {
        errorPrefix = 'Нет такой ошибки)):'
      }
      this.fullErrorMessage = errorPrefix + newVal
    }
  },
  computed: {
    uploaded() {
      if (this.uploadStatus == 'uploaded') {
        return true
      }
      return false
    },
    darkenImage() {
      if (this.uploaded) {
        return false
      }
      return true
    },
    showProgress() {
      if (this.uploadProgress == 0 || this.uploadProgress == 100) {
        return false
      }
      if (this.errorMessage) {
        return false
      }
      return true
    },
    showErrorAlert() {
      if (this.errorMessage) {
        return true
      }
      return false
    },
    isImage() {
      if (!this.type) {
        return false
      }
      if (this.type.startsWith('image')) {
        console.log('IS IMAGE')
        return true
      }
      return false
    },
    isVideo() {
      if (!this.type) {
        return false
      }
      if (this.type.startsWith('video')) {
        console.log('IS VIDEO')
        return true
      }
      return false
    }
  },
  methods: {
    reloadFile() {
      this.$emit('reload_file', this.name)
    }
  }
}
</script>

<style></style>
